var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C3.13401 14 0 10.866 0 7H1C1 10.3137 3.68629 13 7 13C9.22085 13 11.1599 11.7934 12.1973 10H9V9H14V14H13V10.6076C11.7751 12.6404 9.54633 14 7 14ZM5 4V5H0V0H1V3.39241C2.2249 1.35958 4.45367 0 7 0C10.866 0 14 3.13401 14 7H13C13 3.68629 10.3137 1 7 1C4.77915 1 2.84012 2.2066 1.80269 4H5Z",
    fill: "#000624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.0a1345f565c6bbd9f32aef7fa8473d9a.svg";
export { ForwardRef as ReactComponent };